module.exports = __webpack_public_path__ + "img/logo.641aceb0.png";